import URLLinkDetector from '../URLLinkDetector'

export default function BreaksDirLinkDetector(textContent) {
  let isUrlExists = textContent.match(/(https?:\/\/[^\s]+)/g)
  return isUrlExists ? URLLinkDetector(textContent) : textContent
}
